

















































import { Vue, Component } from 'vue-property-decorator';
import T from '../../lang';
import homepageSlide from './Slide.vue';
import carouselConfig from '../../carousel.config';

@Component({
  components: {
    'omegaup-homepage-slide': homepageSlide,
  },
})
export default class Carousel extends Vue {
  T = T;
  // Reverse the entries so that newer ones appear first.
  slides = carouselConfig.reverse();
}
